const updateEmailAndPhoneModalStyle = {
    container: `flex flex-col gap-[12px] items-center justify-center rounded-[8px] bg-white p-[25px] pt-[20px] w-full text-black relative
                screen-500:w-[430px]
    `,
    heading: `text-[18px] capitalize font-Suisse`,
    img_heading: `w-full flex items-end gap-[13px]`,
    popup_img: `max-w-[40px] w-full h-auto`,
    closeButton: `absolute top-[1px] right-2`,
    newValueContainer: `relative w-full flex flex-col gap-1`,
    formContainer: `flex flex-col items-center justify-center gap-6 w-full`,
    resendOtp: `text-right text-primaryHeading text-[10px]`,
    button: `w-full`,
    otpContainer: `flex flex-col gap-[30px] w-full`,
    afterOtpreceivedContainer: `flex justify-between`,
    spamNote: `text-gray-500 text-[10px]`,
}

export { updateEmailAndPhoneModalStyle }